import React from 'react';
import { Row, Col, ProgressBar } from 'react-bootstrap';
import './styles.scss';
import { useAuth } from '../../contexts/AuthContext';
import { useHistory } from 'react-router';

import { FaUserAlt, FaTruck, FaUserTie, FaLink, FaFileAlt } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import DocumentosService, { IDocumentoCompletudeService } from '../../services/documentos.service';

const getCompletionVariant = (percentual: number): 'success' | 'warning' | 'danger' => {
  if (percentual >= 80) return 'success';
  if (percentual >= 60) return 'warning';
  return 'danger';
};

const Dashboard: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { user, getImporter } = useAuth();
  const history = useHistory();
  const [completude, setCompletude] = React.useState<IDocumentoCompletudeService | null>(null);

  React.useEffect(() => {
    if (getImporter().includes(user?.profileId as number)) {
      history.push('/dashboard-importer', { reload: true });
    }
  }, [user?.profileId]);

  const loadCompletude = React.useCallback(async (exportadorId: number): Promise<void> => {
    try {
      const res = await DocumentosService.getCompletude(exportadorId);
      setCompletude(res);
    } catch (error) {
      //eslint-disable-next-line
      console.log(error);
    }
  }, []);

  React.useEffect(() => {
    if (user?.default_company?.id) {
      loadCompletude(user.default_company.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.default_company?.id]);

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Dashboard</h1>

      {completude && (
        <div className="documents-completion">
          <h2 className="steps-title">{t('titles.titleDocumentsCompletion')}</h2>
          <hr className="divider" />

          <div className="completion-overall">
            <div className="completion-overall-header">
              <span>{t('labels.labelDocumentsCompletion')}</span>
              <span className="completion-percentage">{completude.percentual}%</span>
            </div>
            <ProgressBar now={completude.percentual} label={`${completude.percentual}%`} />
            <p className="completion-count">
              {t('messages.messageDocumentsCompletionCount', {
                preenchidos: completude.totalPreenchidos,
                total: completude.totalTipos,
              })}
            </p>
          </div>

          <div className="completion-groups-list">
            {[...completude.grupos]
              .sort((a, b) => b.percentual - a.percentual)
              .map((grupo) => (
                <div key={grupo.grupo_id} className="completion-group-row">
                  <div className="completion-group-label">
                    {i18n.language === 'en' ? grupo.titulo_en : grupo.titulo}
                  </div>
                  <div className="completion-group-bar">
                    <ProgressBar
                      now={grupo.percentual}
                      label={`${grupo.percentual}%`}
                      variant={getCompletionVariant(grupo.percentual)}
                    />
                  </div>
                  <div className="completion-group-count">
                    {grupo.preenchidos}/{grupo.total}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      <div className="supply-chain-steps">
        <h2 className="steps-title">{t('titles.titleDashboard')}</h2>
        <hr className="divider" />

        <Row className="steps-row">
          <Col className="step-col cursor-pointer" onClick={() => history.push('/industry')}>
            <div className="step-icon">
              <FaUserAlt />
            </div>
            <div className="step-arrow">→</div>
            <div className="step-number">1. {t('labels.labelPerfil').toUpperCase()}</div>
            <p className="step-description">{t('headers.headerProfile')}</p>
            <p className="step-note">{t('headers.headerProfile2')}</p>
          </Col>

          <Col className="step-col cursor-pointer" onClick={() => history.push('/new-fornecedor')}>
            <div className="step-icon">
              <FaTruck />
            </div>
            <div className="step-arrow">→</div>
            <div className="step-number">2. {t('labels.exporterName').toUpperCase()}</div>
            <p className="step-description">{t('headers.headerSupplier')}</p>
          </Col>

          <Col className="step-col cursor-pointer" onClick={() => history.push('/new-client')}>
            <div className="step-icon">
              <FaUserTie />
            </div>
            <div className="step-arrow">→</div>
            <div className="step-number">3. {t('titles.clients').toUpperCase()}</div>
            <p className="step-description">{t('headers.headerImporter')}</p>
          </Col>

          <Col className="step-col cursor-pointer" onClick={() => history.push('/new-supply')}>
            <div className="step-icon">
              <FaLink />
            </div>
            <div className="step-arrow">→</div>
            <div className="step-number">4. {t('titles.eudr').toUpperCase()}</div>
            <p className="step-description">{t('headers.headerSupplyChain')}</p>
          </Col>

          <Col className="step-col cursor-pointer" onClick={() => history.push('/supplychain')}>
            <div className="step-icon">
              <FaFileAlt />
            </div>
            <div className="step-number">5. {t('titles.supply').toUpperCase()}</div>
            <p className="step-description">{t('headers.headerReports')}</p>
          </Col>
        </Row>
      </div>

      <div className="simple-process">
        <h2 className="simple-title">{t('headers.headerDashboard')}</h2>
        <hr className="divider" />
        <p className="simple-description">{t('messages.responsabilidade')}</p>
      </div>
    </div>
  );
};

export default Dashboard;
